import React from "react";
import Sidebar from "../../../../../_legacy/Containers/Settings/sidebar.js";

export const PaperworkLayout = ({ children }) => {
  return (
    <div id="content">
      <div className="container-fluid content setting-wrapper">
        <Sidebar />
        <div className="business-setion memberWalletOuter">{children}</div>
      </div>
    </div>
  );
};
